// Note sakuma ファイルアップロード画面（通常）
import React, { useState, memo, useEffect, useCallback } from 'react';
import Heading from '../molecules/Heading';
import Annotation from '../atoms/Annotation';
import FileUploadShelf from '../molecules/FileUploadShelf';
import { Reception, SetShelfInfo, ShelfInfoObj } from '../types/FileUpload';
import LoadingModal from '../molecules/LoadingModal';
import PreviewModal from '../molecules/PreviewModal';
import { guarantors_limit, loan_types } from '../Const';
import {
  mime_type_white_list,
  preview_modal_init,
  default_shelf_open,
  process_upload,
  proposer_cd,
} from '../const/FileUpload';
import { GuarantorInfo } from '../types/Template';
interface Props {
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception: Reception;
  looks_inactive: boolean;
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  is_open_guarantor_1?: boolean;
  is_open_guarantor_2?: boolean;
  is_open_guarantor_3?: boolean;
  is_open_guarantor_4?: boolean;
  is_open_guarantor_5?: boolean;
  is_open_guarantor_6?: boolean;
  is_open_guarantor_7?: boolean;
  is_open_guarantor_8?: boolean;
  is_open_guarantor_9?: boolean;
  is_open_guarantor_10?: boolean;
  is_open_guarantor_11?: boolean;
  is_open_guarantor_12?: boolean;
  is_open_guarantor_13?: boolean;
  is_open_guarantor_14?: boolean;
  is_open_guarantor_15?: boolean;
  is_open_guarantor_16?: boolean;
  is_open_guarantor_17?: boolean;
  is_open_guarantor_18?: boolean;
  is_open_guarantor_19?: boolean;
  is_open_guarantor_20?: boolean;
  loan_type?: string | null;
  guarantor_accordion_hidden?: boolean;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

interface StringKeyObject {
  [key: string]: boolean;
}

const FileUpload: React.FC<Props> = ({
  shelf_info,
  setShelfInfo,
  reception,
  looks_inactive,
  guarantors_num,
  guarantor_info,
  is_open_guarantor_1,
  is_open_guarantor_2,
  is_open_guarantor_3,
  is_open_guarantor_4,
  is_open_guarantor_5,
  is_open_guarantor_6,
  is_open_guarantor_7,
  is_open_guarantor_8,
  is_open_guarantor_9,
  is_open_guarantor_10,
  is_open_guarantor_11,
  is_open_guarantor_12,
  is_open_guarantor_13,
  is_open_guarantor_14,
  is_open_guarantor_15,
  is_open_guarantor_16,
  is_open_guarantor_17,
  is_open_guarantor_18,
  is_open_guarantor_19,
  is_open_guarantor_20,
  loan_type,
  guarantor_accordion_hidden, // 連帯債務・連帯保証アコーディオンの提出書類が非表示か
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  const [is_loading, setIsLoading] = useState(false);
  // PreviewModal設定
  const [preview_modal, setPreviewModal] = useState(preview_modal_init);
  // 画面描画時の棚の開閉状態をコントロールする
  const [shelf_open, setShelfOpen] = useState<StringKeyObject>(default_shelf_open);
  // URLを取得する
  const url = location.href.split('/');
  const process_mode = url.pop();

  // LoadingModalの操作
  const setLoadingModalShow = (show: boolean) => {
    setIsLoading(show);
  };

  useEffect(() => {
    const saved_shelf_open = sessionStorage.getItem('shelf_open');
    if (process_mode === process_upload && saved_shelf_open !== null) {
      setShelfOpen(JSON.parse(saved_shelf_open));
    }
  }, []);

  useEffect(() => {
    const saved_shelf_open = sessionStorage.getItem('shelf_open');
    // 連帯債務者の棚の開閉状況をコントロールする
    if (saved_shelf_open === null) {
      const new_shelf_open = { ...shelf_open };
      // 連帯債務者1
      if (is_open_guarantor_1) {
        new_shelf_open.F = true;
        new_shelf_open.G = true;
      }
      // 連帯債務者2
      if (is_open_guarantor_2) {
        new_shelf_open.H = true;
        new_shelf_open.I = true;
      }
      // 連帯債務者3
      if (is_open_guarantor_3) {
        new_shelf_open.J = true;
        new_shelf_open.K = true;
      }
      // 連帯債務者4
      if (is_open_guarantor_4) {
        new_shelf_open.AA = true;
        new_shelf_open.AB = true;
      }
      // 連帯債務者5
      if (is_open_guarantor_5) {
        new_shelf_open.AC = true;
        new_shelf_open.AD = true;
      }
      // 連帯債務者6
      if (is_open_guarantor_6) {
        new_shelf_open.AE = true;
        new_shelf_open.AF = true;
      }
      // 連帯債務者7
      if (is_open_guarantor_7) {
        new_shelf_open.AG = true;
        new_shelf_open.AH = true;
      }
      // 連帯債務者8
      if (is_open_guarantor_8) {
        new_shelf_open.AI = true;
        new_shelf_open.AJ = true;
      }
      // 連帯債務者9
      if (is_open_guarantor_9) {
        new_shelf_open.AK = true;
        new_shelf_open.AL = true;
      }
      // 連帯債務者10
      if (is_open_guarantor_10) {
        new_shelf_open.AM = true;
        new_shelf_open.AN = true;
      }
      // 連帯債務者11
      if (is_open_guarantor_11) {
        new_shelf_open.AO = true;
        new_shelf_open.AP = true;
      }
      // 連帯債務者12
      if (is_open_guarantor_12) {
        new_shelf_open.AQ = true;
        new_shelf_open.AR = true;
      }
      // 連帯債務者13
      if (is_open_guarantor_13) {
        new_shelf_open.AS = true;
        new_shelf_open.AT = true;
      }
      // 連帯債務者14
      if (is_open_guarantor_14) {
        new_shelf_open.AU = true;
        new_shelf_open.AV = true;
      }
      // 連帯債務者15
      if (is_open_guarantor_15) {
        new_shelf_open.AW = true;
        new_shelf_open.AX = true;
      }
      // 連帯債務者16
      if (is_open_guarantor_16) {
        new_shelf_open.AY = true;
        new_shelf_open.AZ = true;
      }
      // 連帯債務者17
      if (is_open_guarantor_17) {
        new_shelf_open.BA = true;
        new_shelf_open.BB = true;
      }
      // 連帯債務者18
      if (is_open_guarantor_18) {
        new_shelf_open.BC = true;
        new_shelf_open.BD = true;
      }
      // 連帯債務者19
      if (is_open_guarantor_19) {
        new_shelf_open.BE = true;
        new_shelf_open.BF = true;
      }
      // 連帯債務者20
      if (is_open_guarantor_20) {
        new_shelf_open.BG = true;
        new_shelf_open.BH = true;
      }
      setShelfOpen(new_shelf_open);
    }
  }, [
    is_open_guarantor_1,
    is_open_guarantor_2,
    is_open_guarantor_3,
    is_open_guarantor_4,
    is_open_guarantor_5,
    is_open_guarantor_6,
    is_open_guarantor_7,
    is_open_guarantor_8,
    is_open_guarantor_9,
    is_open_guarantor_10,
    is_open_guarantor_11,
    is_open_guarantor_12,
    is_open_guarantor_13,
    is_open_guarantor_14,
    is_open_guarantor_15,
    is_open_guarantor_16,
    is_open_guarantor_17,
    is_open_guarantor_18,
    is_open_guarantor_19,
    is_open_guarantor_20,
  ]);

  // PreviewModalの操作
  const setPreviewModalShow = (
    show: boolean,
    image_source: string,
    width: number,
    height: number,
    mime: string
  ) => {
    // MIMEがホワイトリストに入っていない場合
    if (!mime_type_white_list.includes(mime)) {
      return;
    }

    const new_preview_modal = { ...preview_modal };
    new_preview_modal.is_show = show;
    new_preview_modal.image_source = image_source;
    new_preview_modal.image_width = width;
    new_preview_modal.image_height = height;
    setPreviewModal(new_preview_modal);
  };

  // 棚の初期開閉状態を変更する
  const updateDefaultShelfOpen = (shelf_type: string, open_flag: boolean) => {
    const new_shelf_open = { ...shelf_open };
    new_shelf_open[shelf_type] = open_flag;
    setShelfOpen(new_shelf_open);

    // SessionStorageに状態を保存する
    if (process_mode === process_upload) {
      sessionStorage.setItem('shelf_open', JSON.stringify(new_shelf_open));
    }
  };

  return (
    <>
      {(loan_type === loan_types.business_improvement_financing_plan ||
        loan_type === loan_types.modernization_funds) && (
        <>
          {looks_inactive ? (
            <>
              <Heading label="提出書類" size="m" />
              <Heading
                label="お申込人）経営改善資金計画書（5ヵ年収支計画）"
                size="s"
                css_class="out"
              />
            </>
          ) : (
            <>
              <Heading label=" お申込人）経営改善資金計画書（5ヵ年収支計画）" size="m" />
              <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
              <p>
                ５ヵ年収支計画が必要とされた場合のみご提出下さい。書類提出の要否については、各JAへおたずね下さい。
              </p>
            </>
          )}
          <FileUploadShelf
            shelf_type="BI"
            label={
              <>
                お申込人）経営改善資金計画書
                <br className="d-lg-none" />
                （5ヵ年収支計画）
              </>
            }
            is_open={shelf_open.BI}
            shelf_info={shelf_info.shelf_info_bi}
            setLoadingModalShow={setLoadingModalShow}
            setPreviewModalShow={setPreviewModalShow}
            setShelfInfo={setShelfInfo.setShelfInfoBI}
            reception={reception}
            looks_inactive={looks_inactive}
            updateDefaultShelfOpen={updateDefaultShelfOpen}
            proposer_cd={proposer_cd.applicant}
          />
        </>
      )}

      {looks_inactive ? (
        <>
          {/**近代資金の場合は非表示 */}
          {loan_type !== loan_types.business_improvement_financing_plan &&
            loan_type !== loan_types.modernization_funds && <Heading label="提出書類" size="m" />}
          <Heading
            label="お申込人）提出書類"
            size="s"
            css_class={`out ${guarantor_info.is_guarantor && 'd-none'}`}
          />
        </>
      ) : (
        <>
          <Heading label="お申込人）提出書類" size="m" />
          <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
          {(loan_type === loan_types.business_improvement_financing_plan ||
            loan_type === loan_types.modernization_funds) && (
            <p>
              認定農業者制度にかかる農業経営改善認定証や農業経営改善計画書、その他農業近代化資金のお申込みに必要となる書類は、以下の資金使途資料の「その他書類」を選択のうえ、アップロードして下さい。
            </p>
          )}
        </>
      )}
      {!guarantor_info.is_guarantor && (
        <>
          <FileUploadShelf
            shelf_type="A"
            label="お申込人）本人確認資料"
            is_open={shelf_open.A}
            shelf_info={shelf_info.shelf_info_a}
            setLoadingModalShow={setLoadingModalShow}
            setPreviewModalShow={setPreviewModalShow}
            setShelfInfo={setShelfInfo.setShelfInfoA}
            reception={reception}
            looks_inactive={looks_inactive}
            updateDefaultShelfOpen={updateDefaultShelfOpen}
            proposer_cd={proposer_cd.applicant}
          />
          <FileUploadShelf
            shelf_type="B"
            label="お申込人）所得証明"
            is_open={shelf_open.B}
            shelf_info={shelf_info.shelf_info_b}
            setLoadingModalShow={setLoadingModalShow}
            setPreviewModalShow={setPreviewModalShow}
            setShelfInfo={setShelfInfo.setShelfInfoB}
            reception={reception}
            looks_inactive={looks_inactive}
            updateDefaultShelfOpen={updateDefaultShelfOpen}
            proposer_cd={proposer_cd.applicant}
          />
          {/**有担保 の場合に表示 */}
          {is_secured && (
            <FileUploadShelf
              shelf_type="C"
              label="お申込人）資金使途資料"
              is_open={shelf_open.C}
              shelf_info={shelf_info.shelf_info_c}
              setLoadingModalShow={setLoadingModalShow}
              setPreviewModalShow={setPreviewModalShow}
              setShelfInfo={setShelfInfo.setShelfInfoC}
              reception={reception}
              looks_inactive={looks_inactive}
              updateDefaultShelfOpen={updateDefaultShelfOpen}
              proposer_cd={proposer_cd.applicant}
            />
          )}
          {/**無担保 の場合に表示 */}
          {is_unsecured && (
            <FileUploadShelf
              shelf_type="D"
              label="お申込人）資金使途資料"
              is_open={shelf_open.D}
              shelf_info={shelf_info.shelf_info_d}
              setLoadingModalShow={setLoadingModalShow}
              setPreviewModalShow={setPreviewModalShow}
              setShelfInfo={setShelfInfo.setShelfInfoD}
              reception={reception}
              looks_inactive={looks_inactive}
              updateDefaultShelfOpen={updateDefaultShelfOpen}
              proposer_cd={proposer_cd.applicant}
            />
          )}
          {/**農業資金または近代化資金 の時に表示 */}
          {is_agricultural_modernization_funds && (
            <FileUploadShelf
              shelf_type="E"
              label="お申込人）資金使途資料"
              is_open={shelf_open.E}
              shelf_info={shelf_info.shelf_info_e}
              setLoadingModalShow={setLoadingModalShow}
              setPreviewModalShow={setPreviewModalShow}
              setShelfInfo={setShelfInfo.setShelfInfoE}
              reception={reception}
              looks_inactive={looks_inactive}
              updateDefaultShelfOpen={updateDefaultShelfOpen}
              proposer_cd={proposer_cd.applicant}
            />
          )}
        </>
      )}
      {!guarantor_accordion_hidden && (
        <>
          {guarantor_info.guarantor_1 && guarantors_limit.first <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証①）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証①）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="F"
                label={
                  <>
                    連帯債務・連帯保証①）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.F}
                shelf_info={shelf_info.shelf_info_f}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoF}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor1}
              />
              <FileUploadShelf
                shelf_type="G"
                label={
                  <>
                    連帯債務・連帯保証①）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.G}
                shelf_info={shelf_info.shelf_info_g}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoG}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor1}
              />
            </>
          )}
          {guarantor_info.guarantor_2 && guarantors_limit.second <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証②）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証②）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="H"
                label={
                  <>
                    連帯債務・連帯保証②）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.H}
                shelf_info={shelf_info.shelf_info_h}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoH}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor2}
              />
              <FileUploadShelf
                shelf_type="I"
                label={
                  <>
                    連帯債務・連帯保証②）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.I}
                shelf_info={shelf_info.shelf_info_i}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoI}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor2}
              />
            </>
          )}

          {guarantor_info.guarantor_3 && guarantors_limit.three <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証③）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証③）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="J"
                label={
                  <>
                    連帯債務・連帯保証③）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.J}
                shelf_info={shelf_info.shelf_info_j}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoJ}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor3}
              />
              <FileUploadShelf
                shelf_type="K"
                label={
                  <>
                    連帯債務・連帯保証③）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.K}
                shelf_info={shelf_info.shelf_info_k}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoK}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor3}
              />
            </>
          )}

          {/**連帯債務者４人 */}
          {guarantor_info.guarantor_4 && guarantors_limit.fourth <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証④）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証④）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AA"
                label={
                  <>
                    連帯債務・連帯保証④）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AA}
                shelf_info={shelf_info.shelf_info_aa}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAA}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor4}
              />
              <FileUploadShelf
                shelf_type="AB"
                label={
                  <>
                    連帯債務・連帯保証④）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AB}
                shelf_info={shelf_info.shelf_info_ab}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAB}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor4}
              />
            </>
          )}

          {/**連帯債務者５人 */}
          {guarantor_info.guarantor_5 && guarantors_limit.five <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑤）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑤）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AC"
                label={
                  <>
                    連帯債務・連帯保証⑤）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AC}
                shelf_info={shelf_info.shelf_info_ac}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAC}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor5}
              />
              <FileUploadShelf
                shelf_type="AD"
                label={
                  <>
                    連帯債務・連帯保証⑤）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AD}
                shelf_info={shelf_info.shelf_info_ad}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAD}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor5}
              />
            </>
          )}

          {/**連帯債務者６人 */}
          {guarantor_info.guarantor_6 && guarantors_limit.six <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑥）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑥）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AE"
                label={
                  <>
                    連帯債務・連帯保証⑥）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AE}
                shelf_info={shelf_info.shelf_info_ae}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAE}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor6}
              />
              <FileUploadShelf
                shelf_type="AF"
                label={
                  <>
                    連帯債務・連帯保証⑥）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AF}
                shelf_info={shelf_info.shelf_info_af}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAF}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor6}
              />
            </>
          )}

          {/**連帯債務者７人 */}
          {guarantor_info.guarantor_7 && guarantors_limit.seven <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑦）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑦）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AG"
                label={
                  <>
                    連帯債務・連帯保証⑦）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AG}
                shelf_info={shelf_info.shelf_info_ag}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAG}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor7}
              />
              <FileUploadShelf
                shelf_type="AH"
                label={
                  <>
                    連帯債務・連帯保証⑦）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AH}
                shelf_info={shelf_info.shelf_info_ah}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAH}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor7}
              />
            </>
          )}

          {/**連帯債務者８人 */}
          {guarantor_info.guarantor_8 && guarantors_limit.eight <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑧）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑧）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AI"
                label={
                  <>
                    連帯債務・連帯保証⑧）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AI}
                shelf_info={shelf_info.shelf_info_ai}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAI}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor8}
              />
              <FileUploadShelf
                shelf_type="AJ"
                label={
                  <>
                    連帯債務・連帯保証⑧）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AJ}
                shelf_info={shelf_info.shelf_info_aj}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAJ}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor9}
              />
            </>
          )}

          {/**連帯債務者９人 */}
          {guarantor_info.guarantor_9 && guarantors_limit.nine <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑨）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑨）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AK"
                label={
                  <>
                    連帯債務・連帯保証⑨）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AK}
                shelf_info={shelf_info.shelf_info_ak}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAK}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor9}
              />
              <FileUploadShelf
                shelf_type="AL"
                label={
                  <>
                    連帯債務・連帯保証⑨）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AL}
                shelf_info={shelf_info.shelf_info_al}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAL}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor8}
              />
            </>
          )}

          {/**連帯債務者１０人 */}
          {guarantor_info.guarantor_10 && guarantors_limit.ten <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑩）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑩）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AM"
                label={
                  <>
                    連帯債務・連帯保証⑩）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AM}
                shelf_info={shelf_info.shelf_info_am}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAM}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor10}
              />
              <FileUploadShelf
                shelf_type="AN"
                label={
                  <>
                    連帯債務・連帯保証⑩）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AN}
                shelf_info={shelf_info.shelf_info_an}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAN}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor10}
              />
            </>
          )}

          {/**連帯債務者１１人 */}
          {guarantor_info.guarantor_11 && guarantors_limit.eleven <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑪）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑪）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AO"
                label={
                  <>
                    連帯債務・連帯保証⑪）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AO}
                shelf_info={shelf_info.shelf_info_ao}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAO}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor11}
              />
              <FileUploadShelf
                shelf_type="AP"
                label={
                  <>
                    連帯債務・連帯保証⑪）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AP}
                shelf_info={shelf_info.shelf_info_ap}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAP}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor11}
              />
            </>
          )}
          {/**連帯債務者１２人 */}
          {guarantor_info.guarantor_12 && guarantors_limit.twelve <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑫）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑫）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AQ"
                label={
                  <>
                    連帯債務・連帯保証⑫）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AQ}
                shelf_info={shelf_info.shelf_info_aq}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAQ}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor12}
              />
              <FileUploadShelf
                shelf_type="AR"
                label={
                  <>
                    連帯債務・連帯保証⑫）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AR}
                shelf_info={shelf_info.shelf_info_ar}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAR}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor12}
              />
            </>
          )}

          {/**連帯債務者１３人 */}
          {guarantor_info.guarantor_13 && guarantors_limit.thirteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑬）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑬）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AS"
                label={
                  <>
                    連帯債務・連帯保証⑬）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AS}
                shelf_info={shelf_info.shelf_info_as}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAS}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor13}
              />
              <FileUploadShelf
                shelf_type="AT"
                label={
                  <>
                    連帯債務・連帯保証⑬）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AT}
                shelf_info={shelf_info.shelf_info_at}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAT}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor13}
              />
            </>
          )}

          {/**連帯債務者１４人 */}
          {guarantor_info.guarantor_14 && guarantors_limit.fourteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑭）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑭）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AU"
                label={
                  <>
                    連帯債務・連帯保証⑭）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AU}
                shelf_info={shelf_info.shelf_info_au}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAU}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor14}
              />
              <FileUploadShelf
                shelf_type="AV"
                label={
                  <>
                    連帯債務・連帯保証⑭）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AV}
                shelf_info={shelf_info.shelf_info_av}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAV}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor14}
              />
            </>
          )}

          {/**連帯債務者１５人 */}
          {guarantor_info.guarantor_15 && guarantors_limit.fifteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑮）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑮）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AW"
                label={
                  <>
                    連帯債務・連帯保証⑮）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AW}
                shelf_info={shelf_info.shelf_info_aw}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAW}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor15}
              />
              <FileUploadShelf
                shelf_type="AX"
                label={
                  <>
                    連帯債務・連帯保証⑮）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AX}
                shelf_info={shelf_info.shelf_info_ax}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAX}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor15}
              />
            </>
          )}

          {/**連帯債務者１６人 */}
          {guarantor_info.guarantor_16 && guarantors_limit.sixteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑯）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑯）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="AY"
                label={
                  <>
                    連帯債務・連帯保証⑯）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.AY}
                shelf_info={shelf_info.shelf_info_ay}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAY}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor16}
              />
              <FileUploadShelf
                shelf_type="AZ"
                label={
                  <>
                    連帯債務・連帯保証⑯）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.AZ}
                shelf_info={shelf_info.shelf_info_az}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoAZ}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor16}
              />
            </>
          )}

          {/**連帯債務者１７人 */}
          {guarantor_info.guarantor_17 && guarantors_limit.seventeen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑰）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑰）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="BA"
                label={
                  <>
                    連帯債務・連帯保証⑰）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.BA}
                shelf_info={shelf_info.shelf_info_ba}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBA}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor17}
              />
              <FileUploadShelf
                shelf_type="BB"
                label={
                  <>
                    連帯債務・連帯保証⑰）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.BB}
                shelf_info={shelf_info.shelf_info_bb}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBB}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor17}
              />
            </>
          )}

          {/**連帯債務者１８人 */}
          {guarantor_info.guarantor_18 && guarantors_limit.eighteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑱）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑱）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="BC"
                label={
                  <>
                    連帯債務・連帯保証⑱）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.BC}
                shelf_info={shelf_info.shelf_info_bc}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBC}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor18}
              />
              <FileUploadShelf
                shelf_type="BD"
                label={
                  <>
                    連帯債務・連帯保証⑱）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.BD}
                shelf_info={shelf_info.shelf_info_bd}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBD}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor18}
              />
            </>
          )}

          {/**連帯債務者１９人 */}
          {guarantor_info.guarantor_19 && guarantors_limit.nineteen <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑲）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑲）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="BE"
                label={
                  <>
                    連帯債務・連帯保証⑲）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.BE}
                shelf_info={shelf_info.shelf_info_be}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBE}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor19}
              />
              <FileUploadShelf
                shelf_type="BF"
                label={
                  <>
                    連帯債務・連帯保証⑲）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.BF}
                shelf_info={shelf_info.shelf_info_bf}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBF}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor19}
              />
            </>
          )}

          {/**連帯債務者２０人 */}
          {guarantor_info.guarantor_20 && guarantors_limit.twenty <= guarantors_num && (
            <>
              {looks_inactive ? (
                <>
                  <Heading label="連帯債務・連帯保証⑳）提出書類" size="s" css_class="out" />
                </>
              ) : (
                <>
                  <Heading label="連帯債務・連帯保証⑳）提出書類" size="m" />
                  <Annotation text="手続きに必要な書類を用意し、アップロードして下さい。" />
                </>
              )}
              <FileUploadShelf
                shelf_type="BG"
                label={
                  <>
                    連帯債務・連帯保証⑳）
                    <br className="d-lg-none" />
                    本人確認資料
                  </>
                }
                is_open={shelf_open.BG}
                shelf_info={shelf_info.shelf_info_bg}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBG}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor20}
              />
              <FileUploadShelf
                shelf_type="BH"
                label={
                  <>
                    連帯債務・連帯保証⑳）
                    <br className="d-lg-none" />
                    所得証明
                  </>
                }
                is_open={shelf_open.BH}
                shelf_info={shelf_info.shelf_info_bh}
                setLoadingModalShow={setLoadingModalShow}
                setPreviewModalShow={setPreviewModalShow}
                setShelfInfo={setShelfInfo.setShelfInfoBH}
                reception={reception}
                looks_inactive={looks_inactive}
                updateDefaultShelfOpen={updateDefaultShelfOpen}
                proposer_cd={proposer_cd.guarantor20}
              />
            </>
          )}
        </>
      )}

      <PreviewModal
        show={preview_modal.is_show}
        image_source={preview_modal.image_source}
        image_width={preview_modal.image_width}
        image_height={preview_modal.image_height}
        handleOnclick={() => {
          const new_preview_modal = { ...preview_modal };
          new_preview_modal.is_show = false;
          setPreviewModal(new_preview_modal);
        }}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default memo(FileUpload);
